const coursesEnabledForAiHintsB2B = [
// Python
735, 799, 22066, 28314, 1532, 22639,
// R
58, 672, 4914,
// SQL
29302, 29303, 29304, 13367,
// GPU (REMOVE)
26146];
const coursesEnabledForAiHints = [...coursesEnabledForAiHintsB2B,
// Python
25412,
// R
20822];
export const aiFeatureConfig = {
  aiHints: {
    b2bEnabled: true,
    b2bEnabledCourseIds: coursesEnabledForAiHintsB2B,
    b2bFlag: 'aiErrorExplanationEnabled',
    enabledCourseIds: coursesEnabledForAiHints,
    enabledExerciseTypes: ['NormalExercise', 'GpuExercise']
  }
};
const isAiFeatureEnabledForB2BUsers = _ref => {
  let {
    config,
    courseId,
    isB2BFlagEnabled
  } = _ref;
  if (config.b2bFlag === undefined) {
    return false;
  }
  if (!isB2BFlagEnabled) {
    return false;
  }
  if (config.b2bEnabledCourseIds === undefined) {
    return true;
  }
  if (config.b2bEnabledCourseIds !== 'all' && !config.b2bEnabledCourseIds.includes(courseId)) {
    return false;
  }
  return true;
};
export const isAiFeatureEnabled = _ref2 => {
  let {
    courseId,
    exerciseType,
    feature,
    isB2BFlagEnabled,
    isSplitFlagEnabled,
    isUserB2B,
    isUserFromDatacamp
  } = _ref2;
  const config = aiFeatureConfig[feature];
  if (config.enabledCourseIds !== 'all' && !config.enabledCourseIds.includes(courseId)) {
    return false;
  }
  if (!config.enabledExerciseTypes.includes(exerciseType)) {
    return false;
  }
  if (isUserFromDatacamp) {
    return true;
  }
  if (isUserB2B) {
    return isAiFeatureEnabledForB2BUsers({
      config,
      courseId,
      isB2BFlagEnabled
    });
  }
  return isSplitFlagEnabled;
};